import { useEffect, useState } from "react"
import { fromBase64Url } from "../../../utils/strings.utils"
import { decryptClientReportData } from "../../../services/clientReport.service"
import { CLIENT_REPORT_ALWAYS_VISIBLE_SECTIONS } from "../../../consts/modules/clientReport.consts"

const usePresentationMode = ({ token = "", visibleMapParam = [] }) => {
  const [reportData, setReportData] = useState(null)
  const [visibleMap, setVisibleMap] = useState({
    TITLE: true,
    SUMMARY: true,
    HOUR_CONSUMPTION: true,
    GROUPED: {
      POINT_PROGRESS: true,
      BUDGET_STATE: true,
    },
    DETAILED_ESTIMATION: true,
    HORIZON_ESTIMATION: true,
    BURNCHART: true,
    NOTES: true,
  })
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchReportData = async () => {
      if (!token) return

      setLoading(true)
      setError(null)

      try {
        let updatedVisibleMap = { ...visibleMap }

        if (visibleMapParam) {
          const decodedArray = JSON.parse(fromBase64Url(visibleMapParam))

          const applyVisibleArray = (map, paths) => {
            Object.keys(map).forEach((key) => {
              if (CLIENT_REPORT_ALWAYS_VISIBLE_SECTIONS.includes(key)) return

              if (typeof map[key] === "object" && map[key] !== null) {
                applyVisibleArray(map[key], [])
              } else {
                map[key] = false
              }
            })

            paths.forEach((path) => {
              const keys = path.split(".")
              let current = map

              keys.forEach((key, index) => {
                if (index === keys.length - 1) {
                  current[key] = true
                } else {
                  current = current[key]
                }
              })
            })

            return map
          }

          updatedVisibleMap = applyVisibleArray(updatedVisibleMap, decodedArray)
        }

        setVisibleMap(updatedVisibleMap)

        const response = await decryptClientReportData(token)
        if (!response.success) {
          throw new Error("Error fetching sprint data")
        }

        const data = response.result

        setReportData({
          sprintData: {
            ...data,
          },
          clientId: data.clientData.clientId,
          clientName: data.clientData.clientName,
          clientLogo: data.clientData.logoUrl,
        })
      } catch (err) {
        console.error("Error loading client report:", err)
        setError(err)
      } finally {
        setLoading(false)
      }
    }

    fetchReportData()
  }, [token, visibleMapParam])

  return {
    reportData,
    visibleMap,
    loading,
    error,
  }
}

export default usePresentationMode
